import type { LocalizedDict } from '../index'

type AccountStrings = {
  logout: string
  pageTitle: string
  profileTab: string
  securityTab: string
  permissionsTab: string
  displayName: string
  email: string
  language: string
  save: string
  saved: string
  maketNote: string
  statusActive: string
  roleLabels: {
    admin: string
    seller: string
    supply: string
  }
}

export const ACCOUNT_STRINGS: LocalizedDict<AccountStrings> = {
  en: {
    logout: 'Log out',
    pageTitle: 'My account',
    profileTab: 'Profile',
    securityTab: 'Security',
    permissionsTab: 'My permissions',
    displayName: 'Display name',
    email: 'Email',
    language: 'Language',
    save: 'Save changes',
    saved: 'Saved ✓',
    maketNote: 'Profile editing is available after logging in with a real account.',
    statusActive: 'Active',
    roleLabels: {
      admin: 'Admin',
      seller: 'Seller',
      supply: 'Supply',
    },
  },
  tr: {
    logout: 'Çıkış yap',
    pageTitle: 'Hesabım',
    profileTab: 'Profil',
    securityTab: 'Güvenlik',
    permissionsTab: 'Yetkilerim',
    displayName: 'Görünen ad',
    email: 'E-posta',
    language: 'Dil',
    save: 'Değişiklikleri kaydet',
    saved: 'Kaydedildi ✓',
    maketNote: 'Profil düzenleme gerçek hesapla giriş yaptıktan sonra kullanılabilir.',
    statusActive: 'Aktif',
    roleLabels: {
      admin: 'Admin',
      seller: 'Satıcı',
      supply: 'Üretim',
    },
  },
}
